import { Warehouse } from 'entities/Warehouse';

import { StepData, stepsMapper } from 'features/Stepper';

export enum CreateZoneSteps {
  ADD_NAME = 'Add name and warehouse',
  SELECT_DOORS = 'Select doors',
  SELECT_USERS = 'Select users',
}

export const createZoneSteps = stepsMapper([...Object.values(CreateZoneSteps)]);

export interface ZoneBasics {
  name: string;
  warehouse: Nullable<Warehouse>;
}

export interface CreateZoneModalSchema {
  isOpened: boolean;
  steps: StepData[];
  basics: Nullable<ZoneBasics>;
  selectedBoxIds: string[];
  selectedDoorIds: string[];
  selectedUserIds: string[];
}

export enum BoxesListFilterKeys {
  floorId = 'floorId',
}

export interface Door {
  internalEquipmentId: string;
  name: string;
  lockAddress?: string | null;
}
